// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Lora', 'Lora Fallback'","fontStyle":"normal"},"className":"__className_c1a059","variable":"__variable_c1a059"};